import { ReportsGroupBy } from '@models/interfaces';

export const PROJECT_DURATION_CHART_COLORS = {
  averageByGroup: '#f2c94c',
  distribution: '#40a9ff',
  trend: '#03ffd2',
};

export const PROJECT_DURATION_GROUP_TITLE_BY_GROUP_BY: Partial<
  Record<ReportsGroupBy, string>
> = {
  [ReportsGroupBy.ProgressStatus]: 'Progress Status',
  [ReportsGroupBy.ProjectStatus]: 'Project Status',
  [ReportsGroupBy.ProjectSubtype]: 'Project Subtype',
  [ReportsGroupBy.ProjectType]: 'Project Type',
  [ReportsGroupBy.ProvidenceAgent]: 'Providence Agent',
  [ReportsGroupBy.State]: 'State',
  [ReportsGroupBy.Submarket]: 'Submarket',
  [ReportsGroupBy.TowerOwner]: 'Tower Owner',
};
